import { AppDataState } from './app-data-store';
import { FormConfigurationsClass } from './interface/form-configuration';

export const SET_GET_FORM_CONFIGURATIONS = 'SET_GET_FORM_CONFIGURATIONS';

export type SetGetFormConfigurationsAction = {
  type: typeof SET_GET_FORM_CONFIGURATIONS;
  payload: FormConfigurationsClass;
};

// redux update store action
export const setGetFormConfigurationsAction = (
  payload: FormConfigurationsClass
): SetGetFormConfigurationsAction => {
  return {
    type: SET_GET_FORM_CONFIGURATIONS,
    payload,
  };
};

// redux reducer handler - state updater
export const setGetFormConfigurationsHandler = (
  state: AppDataState,
  action: SetGetFormConfigurationsAction
): AppDataState => {
  return {
    ...state,
    formConfigurations: action.payload,
  };
};
